module.exports = __webpack_public_path__ + "static/Family_Build_My_Book-6e16b4ecba420095027b71ceaf929d5e.jpg";